import angular from 'angular';
import uiRouter from 'angular-ui-router';
import checkboxFormElementComponent from './checkboxFormElement.component';

let checkboxFormElementModule = angular.module('checkboxFormElement', [
  uiRouter
])

.component('checkboxFormElement', checkboxFormElementComponent)

.name;

export default checkboxFormElementModule;
